import './src/modernizr.js'



// WEBPACK FOOTER //
// ./assets/j/head.js